import React, { useEffect, useRef, useState } from 'react';
import {
	MobileProductDetailsWrapper,
	ProductDetailsWrapper,
	ProductVariants,
} from './productdetailst.styled';
import {
	getCurrencySymbol,
	getDiscount,
	saveStateSession,
	loadStateSession,
	NumberFormattinginLocale,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import Button from '../../../../FlyfishComponents/Button';
import Slider from 'react-slick';
import Axios from 'axios';
import Modal from '../../../../FlyfishComponents/Modal';

import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import styled from 'styled-components';

import ProductCard from '../ProductCard';
import usePrevious from './usePrevious';
import EcomCard from '../EcomCard';

export const Slidercarousel = styled.div`
	width: 100%;
	height: fit-content !important;
	max-width: unset !important;
	&.few-products .slick-list .slick-track {
		width: auto !important;
	}
	.slick-slide {
		padding: 2px 20px 2px 0px;
	}
	.ff-image-card {
		max-width: 180px;
		border-radius: 8px;
		position: relative;
		border: 1px solid var(--black-10, rgba(0, 0, 0, 0.1));
		.image {
			border-radius: 8px;
			border-bottom-left-radius: 0px;
			border-bottom-right-radius: 0px;
		}
		.title-price-holder {
			padding: 10px;
		}
		.title {
			color: var(--primary-color-ff-primary900);
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
		}
		.price {
			color: var(--secondary-color-ff-secondary500);
			margin-top: 10px;
			font-weight: 600;
		}
		.slick-prev,
		.slick-next {
			width: 46px;
			height: 46px;
		}
		.ff-rating-morelike {
			position: absolute;
			left: 8px;
			top: 8px;
			display: flex;
			padding: 0px 2px 0px 4px;
			align-items: center;
			background-color: #ffffff59;
			border-radius: 7px;
			font-size: 12px;
			padding-left: 7px;
			padding-right: 7px;
			padding-top: 3px;
			padding-bottom: 3px;
			justify-content: center;
			svg {
				margin-left: 2px;
			}
		}
	}
	& .slick-track {
		display: flex;
	}
`;
export const RightButton = (props) => {
	const { onClick, disabled } = props;

	return (
		<div
			className='right-button'
			onClick={onClick}
			style={{
				background: 'var(--primary-color-ff-primary600)',
				width: '45px',
				height: '45px',
				display: disabled ? 'none' : 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				borderRadius: '25px',
				position: 'absolute',
				right: '0',
				top: '50%',
				zIndex: '1',
			}}>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='36'
				height='36'
				viewBox='0 0 36 36'
				fill='none'>
				<g id='chevron_right'>
					<path
						id='Vector'
						d='M14.5575 9.00031L12.4425 11.1153L19.3125 18.0003L12.4425 24.8853L14.5575 27.0003L23.5575 18.0003L14.5575 9.00031Z'
						fill='white'
					/>
				</g>
			</svg>
		</div>
	);
};
export const LeftButton = (props) => {
	const { onClick, disabled } = props;
	return (
		<div
			onClick={onClick}
			className='left-button'
			style={{
				background: 'var(--primary-color-ff-primary600)',
				width: '45px',
				height: '45px',
				display: disabled ? 'none' : 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				borderRadius: '25px',
				position: 'absolute',
				left: '0',
				top: '50%',
				zIndex: '1',
			}}>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='36'
				height='36'
				viewBox='0 0 36 36'
				fill='none'>
				<g id='chevron_left'>
					<path
						id='Vector'
						d='M23.5575 11.115L21.4425 9L12.4425 18L21.4425 27L23.5575 24.885L16.6875 18L23.5575 11.115Z'
						fill='white'
					/>
				</g>
			</svg>
		</div>
	);
};

const ProductDetails = ({
	mainProduct,
	hideProductDetailsPage,
	conversationId,
	userInput,
	chatMessageIndex,
	advisoryProductId,
	updateChatscreen,
	productIndex,
	messageId,
	intent,
	allProducts,
	userUploadedImage,
	enableCart,
	deviceType,
	colorMode,
	botId,
	tenantId,
	queryText,
	responseId,
	msgId,
	enableStyleAdvisor,
}) => {
	const [slider, setSlider] = useState(null);
	const [slider1, setSlider1] = useState(null);

	const [currentSlide, setCurrentSlide] = useState(0);
	const [totalSlides, setTotalSlides] = useState(0);
	let advisoryproducts = loadStateSession(
		`FF-advisoryproducts-${chatMessageIndex}-${mainProduct.product_id}`
	);
	const [mainProductData, setMainProductData] = useState<any>(mainProduct);
	const [mainProductsVariantImages, setMainProductsVariantImages] = useState(
		[]
	);
	const [moreLikeThis, setMoreLikeThis] = useState([]);
	const [moreLikeThisLoader, setMoreLikeThisLoader] = useState(false);

	const [whyRecommendReason, setWhyRecommendReason] = useState('');
	const [showAddtoBag, setShowAddtoBag] = useState(false);
	const [productAdded, setProductAdded] = useState(false);

	// const [messageIndexChanged, setMessageIndexChanged] = useState(true);
	// const prevChatMessageIndex = usePrevious(chatMessageIndex);
	const prevProductId = usePrevious(
		mainProductData && (mainProductData.product_id ?? mainProductData.productId)
	);

	const [selectedOptions, setSelectedOptions] = useState([]);
	const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
	const [selectedVariant, setSelectedVariant] = useState<any>();
	const [choices, setChoices] = useState([]);
	const [response, setResponse] = useState<any>(null);

	const [slidesToShow, setSlidesToShow] = useState(5); // Default to 7 for the largest breakpoint
	const [isFading, setIsFading] = useState(false);
	const [showRecommendation, setShowRecommendation] = useState(true);
	const [backgroundImageIndex, setBackgroundImageIndex] = useState(0);
	const touchStartX = useRef(0);
	const touchEndX = useRef(0);
	const [productCache, setProductCache] = useState({});
	const [currentProduct, setCurrentProduct] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	useEffect(() => {
		const updateSlidesToShow = () => {
			const width = window.innerWidth;
			let slides = 5;

			if (width < 480) slides = 2;
			else if (width < 768) slides = 3;
			else if (width < 900) slides = 3;
			else if (width < 1024) slides = 3;
			else if (width < 1200) slides = 4;

			setSlidesToShow(slides);
		};

		window.addEventListener('resize', updateSlidesToShow);
		updateSlidesToShow(); // Initial call

		return () => window.removeEventListener('resize', updateSlidesToShow);
	}, []);
	var slidesToShowVar = 5;
	var settings1 = {
		dots: false,
		speed: 500,
		slidesToShow: slidesToShowVar,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		nextArrow: (
			<RightButton
			// disabled={currentSlide >= moreLikeThis.length - slidesToShowVar}
			/>
		),
		prevArrow: (
			<LeftButton
			// disabled={currentSlide === 0}
			/>
		),
		// afterChange: (current) => setCurrentSlide(current),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: slidesToShowVar,
					slidesToScroll: 1,
					dots: true,
					infinite: true,
					// infinite: moreLikeThis.length <= slidesToShowVar ? false : true,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					dots: true,
					infinite: true,
					// infinite: moreLikeThis.length <= 4 ? false : true,
					nextArrow: (
						<RightButton
						// disabled={currentSlide >= moreLikeThis.length - 4}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						//  disabled={currentSlide === 0}
						/>
					),
				},
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
					// infinite: moreLikeThis.length <= 3 ? false : true,
					infinite: true,

					nextArrow: (
						<RightButton
						// disabled={currentSlide >= moreLikeThis.length - 3}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						// disabled={currentSlide === 0}
						/>
					),
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					// infinite: moreLikeThis.length <= 3 ? false : true,
					infinite: true,

					nextArrow: (
						<RightButton
						//  disabled={currentSlide >= moreLikeThis.length - 3}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						// disabled={currentSlide === 0}
						/>
					),
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					// infinite: moreLikeThis.length <= 2 ? false : true,
					infinite: true,

					nextArrow: (
						<RightButton
						// disabled={currentSlide >= moreLikeThis.length - 2}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						//  disabled={currentSlide === 0}
						/>
					),
				},
			},
		],
	};
	var settings = {
		dots: false,
		speed: 500,
		slidesToShow: slidesToShowVar,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		nextArrow: (
			<RightButton
			// disabled={currentSlide >= moreLikeThis.length - slidesToShowVar}
			/>
		),
		prevArrow: (
			<LeftButton
			// disabled={currentSlide === 0}
			/>
		),
		// afterChange: (current) => setCurrentSlide(current),
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: slidesToShowVar,
					slidesToScroll: 1,
					dots: true,
					infinite: true,
					// infinite: moreLikeThis.length <= slidesToShowVar ? false : true,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					dots: true,
					infinite: true,
					// infinite: moreLikeThis.length <= 4 ? false : true,
					nextArrow: (
						<RightButton
						//  disabled={currentSlide >= moreLikeThis.length - 4}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						//  disabled={currentSlide === 0}
						/>
					),
				},
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: true,
					// infinite: moreLikeThis.length <= 3 ? false : true,
					infinite: true,

					nextArrow: (
						<RightButton
						// disabled={currentSlide >= moreLikeThis.length - 3}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						// disabled={currentSlide === 0}
						/>
					),
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					// infinite: moreLikeThis.length <= 3 ? false : true,
					infinite: true,

					nextArrow: (
						<RightButton
						// disabled={currentSlide >= moreLikeThis.length - 3}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						// disabled={currentSlide === 0}
						/>
					),
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					// infinite: moreLikeThis.length <= 2 ? false : true,
					infinite: true,

					nextArrow: (
						<RightButton
						// disabled={currentSlide >= moreLikeThis.length - 2}
						/>
					),
					initialSlide: 1,
					prevArrow: (
						<LeftButton
						// disabled={currentSlide === 0}
						/>
					),
				},
			},
		],
	};
	// useEffect(() => {
	// 	if (slider) {
	// 		setTotalSlides(slider.props.children.length);
	// 	}
	// }, [slider]);
	// useEffect(() => {
	// 	if (slider1) {
	// 		setTotalSlides(slider1.props.children.length);
	// 	}
	// }, [slider1]);
	useEffect(() => {
		// if (advisoryProductId) {
		// 	if (intent.indexOf('direct') > -1 && intent.indexOf('image') === -1) {
		// 		let mainProductD = allProducts.filter((product) => {
		// 			if (product) {
		// 				return product.product_id === advisoryProductId;
		// 			}
		// 		});

		// 		setMainProductData(mainProductD[0]);
		// 	} else if (intent.indexOf('image') > -1) {
		// 		if (intent.indexOf('direct') > -1) {
		// 			let mainProductD = allProducts.filter((product) => {
		// 				if (product) {
		// 					return product.product_id === advisoryProductId;
		// 				}
		// 			});

		// 			setMainProductData(mainProductD[0]);
		// 		} else {
		// 			if (advisoryproducts) {
		// 				let mainProductD = advisoryproducts.filter((product) => {
		// 					if (product[0]) {
		// 						return product[0].productId === advisoryProductId;
		// 					}
		// 				});

		// 				if (mainProductD && mainProductD.length === 0) {
		// 					setMainProductData(mainProduct);
		// 				} else {
		// 					setMainProductData(mainProductD[0][0]);
		// 				}
		// 			}
		// 		}
		// 	} else {
		// 		if (advisoryproducts) {
		// 			let mainProductD = advisoryproducts.filter((product) => {
		// 				if (product[0]) {
		// 					return product[0].productId === advisoryProductId;
		// 				}
		// 			});

		// 			if (mainProductD && mainProductD.length === 0) {
		// 				setMainProductData(mainProduct);
		// 				setShowRecommendation(true);
		// 			} else {
		// 				setShowRecommendation(false);

		// 				setMainProductData(mainProductD[0][0]);
		// 			}
		// 		} else {
		// 			setMainProductData(mainProduct);
		// 		}
		// 	}
		// }
		if (mainProduct) {
			styleAdvisorAPICall(mainProduct.product_id);
		}
	}, [mainProduct]);

	useEffect(() => {
		const fetchProductGridImages = async () => {
			try {
				const res = await Axios.get(
					`${window['BASE_URL']}/shop/${
						loadStateSession('tenantId') ?? loadStateSession('tenantID')
					}/product?productId=${
						mainProductData.product_id ?? mainProductData.productId
					}&country=${loadStateSession('FS-countryCode')}`,
					{
						headers: {
							'x-tenant-id':
								loadStateSession('tenantId') ?? loadStateSession('tenantID'),
							Authorization: `Bearer ${loadStateSession('token')}`,
						},
					}
				);
				if (res.data) {
					let response = res.data.response.data;

					setMainProductsVariantImages(
						response.images ?? [
							mainProductData &&
								(mainProductData.media_link ?? mainProductData.imageUrl),
						]
					);

					setResponse(response);
					setChoices(response.choices);
					setSelectedVariant(response.variants && response.variants[0]);
					setSelectedOptions(response.variants && response.variants[0].options);
					saveStateSession('FF-description', response.description);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		const fetchComplementaryProducts = async () => {
			setMoreLikeThisLoader(true);
			try {
				let payload = {
					id: conversationId,
					botId: loadStateSession('botId') ?? loadStateSession('botID'),
					message: mainProductData && mainProductData.title,
					version: 'prod',
					source: 'web',
					exludeProduct: [
						mainProductData.product_id ?? mainProductData.productId,
					],
				};
				const res = await Axios.post(
					`${window['BASE_URL']}/conversation/similar_product`,
					payload,
					{
						headers: {
							'x-tenant-id':
								loadStateSession('tenantId') ?? loadStateSession('tenantID'),
							Authorization: `Bearer ${loadStateSession('token')}`,
						},
					}
				);
				if (res.data) {
					setMoreLikeThisLoader(false);
					setMoreLikeThis(res.data.metaData.products);
				}
			} catch (error) {
				setMoreLikeThisLoader(false);
				console.error('Error fetching data:', error);
			}
		};
		const fetchRecommendationRatinale = async () => {
			try {
				const res = await Axios.get(
					window['BASE_URL'] +
						`/conversation/tenant/${
							loadStateSession('tenantId') ?? loadStateSession('tenantID')
						}/bot/${
							loadStateSession('botId') ?? loadStateSession('botID')
						}/recommendation_rational?text=${userInput}&conversation_id=${conversationId}&message_id=${messageId}&productId=${
							mainProductData.product_id
						}`,
					{
						headers: {
							Authorization: `Bearer ${loadStateSession('token')}`,
							'x-tenant-id':
								loadStateSession('tenantId') || loadStateSession('tenantID'),
						},
					}
					// {
					// 	id: conversationId,
					// 	message: userInput,
					// 	botId: loadStateSession('botId'),
					// 	version: 'prod',
					// 	country: loadStateSession('FS-countryCode'),
					// 	metaData: { products: [mainProductData] },
					// },
					// {
					// 	headers: {
					// 		'x-tenant-id': loadStateSession('tenantId'),
					// 		Authorization: `Bearer ${loadStateSession('token')}`,
					// 	},
					// }
				);
				if (res.data) {
					setWhyRecommendReason(res.data.products[0].reason);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		if (mainProductData) {
			if (prevProductId !== mainProductData.product_id) {
				if (
					mainProductsVariantImages &&
					mainProductsVariantImages.filter(
						(url) =>
							url === (mainProductData.media_link ?? mainProductData.imageUrl)
					).length
				) {
				} else {
					fetchRecommendationRatinale();
					fetchComplementaryProducts();
					fetchProductGridImages();
				}
			}
		}
	}, [mainProductData]);

	const textWithIcons = (title, description) => {
		return (
			<>
				<div className='title-and-icon-holder'>
					<div className='title'>{title}</div>
				</div>

				<div className='description'>
					<p dangerouslySetInnerHTML={{ __html: description }}></p>
				</div>
			</>
		);
	};
	const handleChange = (event, choiceIndex) => {
		const { value } = event.target;

		const updatedSelectedOptions = [...selectedOptions];
		updatedSelectedOptions[choiceIndex] = {
			type: choices[choiceIndex].type,
			value,
		};
		setSelectedOptions(updatedSelectedOptions);

		// Call a function to find the variant based on selectedOptions
		const selectedVariant = findSelectedVariant(updatedSelectedOptions);

		if (selectedVariant) {
			setSelectedVariant(selectedVariant);
		} else {
			console.log('Variant not found for selected options');
		}
	};
	const findSelectedVariant = (selectedOptions) => {
		const selectedVariantIndex = response.variants.findIndex((variant) =>
			selectedOptions.every((selectedOption) =>
				variant.options.some(
					(variantOption) =>
						variantOption.type === selectedOption.type &&
						variantOption.value === selectedOption.value
				)
			)
		);

		const selectedVariant = response.variants[selectedVariantIndex];
		setSelectedVariantIndex(selectedVariantIndex);
		return selectedVariant;
	};
	const getAnimationClass = (index) => {
		switch (index % 4) {
			case 0:
				return 'left-most-animation';
			case 1:
				return 'left-animation';
			case 2:
				return 'right-most-animation';
			case 3:
				return 'right-animation';
			default:
				return '';
		}
	};
	const handleTouchStart = (e) => {
		touchStartX.current = e.touches[0].clientX;
	};

	const handleTouchMove = (e) => {
		touchEndX.current = e.touches[0].clientX;
	};

	const handleTouchEnd = () => {
		if (touchStartX.current - touchEndX.current > 50) {
			setBackgroundImageIndex(
				(prev) => (prev + 1) % mainProductsVariantImages.length
			);
		}

		if (touchStartX.current - touchEndX.current < -50) {
			setBackgroundImageIndex(
				(prev) =>
					(prev - 1 + mainProductsVariantImages.length) %
					mainProductsVariantImages.length
			);
		}
	};
	const styleAdvisorAPICall = async (product_id) => {
		if (enableStyleAdvisor) {
			if (productCache[product_id]) {
				setCurrentProduct(productCache[product_id]); // Set the cached product
				return;
			}

			setLoading(true);
			setError(null);

			try {
				// API call
				const response = await Axios.post(
					window['BASE_URL'] + `/conversation/style_advisor`,
					{
						product_id: [product_id],
						botId: botId.toString(),
						version: 'prod',
						id: responseId,
						messageId: msgId,
						message: queryText,
					},
					{
						headers: {
							'x-tenant-id': tenantId.toString(),
							Authorization: `Bearer ${loadStateSession('token')}`,
						},
					}
				);

				const resp = response.data.style_advisor_products;

				// Cache the response and set current product
				setProductCache((prevCache) => ({
					...prevCache,
					[product_id]: resp,
				}));
				setCurrentProduct(resp);
			} catch (error) {
				console.error('Error fetching product data:', error);
				setError('Failed to fetch product data. Please try again.');
			} finally {
				setLoading(false);
			}
		}
	};
	// console.log('Price:', mainProductData.price, typeof mainProductData.price);
	// console.log(
	// 	'Sale Price:',
	// 	mainProductData.sale_price,
	// 	typeof mainProductData.sale_price
	// );
	// console.log('MainPrice:', mainProduct.price, typeof mainProduct.price);
	// console.log(
	// 	'MainSale Price:',
	// 	mainProduct.sale_price,
	// 	typeof mainProduct.sale_price
	// );
	return (
		<>
			<ProductDetailsWrapper
				deviceType={deviceType}
				className={`${deviceType}`}
				showAddtoBag={showAddtoBag}
				key={
					chatMessageIndex +
					(mainProductData &&
						(mainProductData.productId ?? mainProductData.product_id))
				}>
				{deviceType !== 'mobile' ? (
					<div className='header-products'>
						<div className='header'>
							<div
								className='backbutton-back'
								onClick={() => hideProductDetailsPage(chatMessageIndex)}>
								<div className='backbutton'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='8'
										height='10'
										viewBox='0 0 8 10'
										fill='none'>
										<path
											d='M7.08748 1.175L5.91248 0L0.912476 5L5.91248 10L7.08748 8.825L3.27081 5L7.08748 1.175Z'
											fill='var(--primary-color-ff-primary900)'
										/>
									</svg>
								</div>
								<div className='back'>Back</div>
							</div>
						</div>
						{intent.indexOf('direct') > -1 ? null : (
							<div className='mainproduct-advisoryproducts'>
								<div
									className={`mainproduct
									${
										mainProductData &&
										(mainProductData.product_id ??
											mainProductData.productId) ===
											(mainProduct.product_id ?? mainProduct.productId)
									}
									
                        `}
									onClick={() => {
										if (intent.indexOf('image') > -1) {
										} else {
											setMainProductData(mainProduct);
										}
									}}>
									<div className='image-holder'>
										<img
											src={
												intent.indexOf('image') > -1
													? userUploadedImage.type === 'upload'
														? 'data:image/png;base64,' + userUploadedImage.url
														: userUploadedImage.url
													: mainProduct.media_link ?? mainProduct.imageUrl
											}
											alt=''
										/>
									</div>
								</div>

								<div className='advisoryproducts'>
									{advisoryproducts !== undefined &&
										advisoryproducts.map((prod, index) => {
											let product = prod[0];
											if (product) {
												return (
													<div
														key={
															product.product_id ??
															product.productId +
																'-' +
																index +
																'-' +
																productIndex +
																'advisoryProducts'
														}
														className={`product ${
															mainProductData &&
															(mainProductData.product_id ??
																mainProductData.productId) ===
																(product.product_id ?? product.productId)
														}`}
														onClick={() => {
															setMainProductData(product);
															setShowRecommendation(false);
														}}>
														<div className='image'>
															<img
																src={product.imageUrl ?? product.media_link}
																alt=''
															/>
														</div>
														<div
															className='productType'
															title={product.productType}>
															{product.productType}
														</div>
													</div>
												);
											}
										})}
								</div>
							</div>
						)}
					</div>
				) : null}

				{deviceType === 'desktop' || deviceType === 'tablet' ? (
					<div className='ff-details-complete-look'>
						<div
							className={`details ${
								loading || (currentProduct && currentProduct.length > 0)
									? ''
									: 'changeWidth'
							}`}>
							<div className='product-details'>
								<div className='all-details'>
									<div className='product-details-rating-title'>
										<div className='title'>
											{mainProductData && mainProductData.title}
										</div>
										<div className='ff-chatbot-body1 brand-name'>
											{mainProductData && mainProductData.brand}
										</div>
										{/* <div className='rating'>
									<div className='number'>4.5</div>
									<div className='stars'>
										{Array.from({ length: 5 }, (_, index) => (
											<>
												{index === 4 ? (
													<svg
														xmlns='http://www.w3.org/2000/svg'
														width='18'
														height='19'
														viewBox='0 0 18 19'
														fill='none'
													>
														<g id='star-half-light'>
															<path
																id='star-half'
																fill-rule='evenodd'
																clip-rule='evenodd'
																d='M4.91396 11.3036L3.43806 17.6306L9 14.2736L14.5619 17.6306L13.086 11.3036L18 7.04662L11.5291 6.49763L9 0.530624L6.47095 6.49763L0 7.04662L4.91396 11.3036ZM13.201 15.7579L9 13.2224V2.83698L10.9121 7.34852L15.7983 7.76303L12.0861 10.9791L13.201 15.7579Z'
																fill='#845B1D'
															/>
														</g>
													</svg>
												) : (
													<>
														<svg
															xmlns='http://www.w3.org/2000/svg'
															width='18'
															height='19'
															viewBox='0 0 18 19'
															fill='none'
														>
															<g id='star-filled-light'>
																<path
																	id='star-filled'
																	d='M14.562 17.6306L9 14.2736L3.438 17.6306L4.914 11.3036L0 7.04662L6.471 6.49762L9 0.530624L11.529 6.49762L18 7.04662L13.086 11.3036L14.562 17.6306Z'
																	fill='#845B1D'
																/>
															</g>
														</svg>
													</>
												)}
											</>
										))}
									</div>
									<div className='users ff-chatbot-body2'>(1k+)</div>
								</div> */}
									</div>
									<div className='product-grid-and-main-image'>
										<div className='product-grid'>
											{mainProductsVariantImages !== undefined &&
											mainProductsVariantImages.length > 0
												? mainProductsVariantImages.map((image, index) => (
														<div
															onClick={() => {
																setIsFading(true);

																setTimeout(() => {
																	setMainProductData((prev) => {
																		let prevData = { ...prev };
																		if (prevData.media_link) {
																			prevData.media_link = image;
																		}
																		if (prevData.imageUrl) {
																			prevData.imageUrl = image;
																		}

																		return prevData;
																	});
																	setIsFading(false);
																}, 500);
															}}
															key={image + index + 'variantImgs'}
															className={`${
																image ===
																(mainProductData &&
																	(mainProductData.media_link ??
																		mainProductData.imageUrl))
															}`}>
															<img src={`${image}`} alt='' />
														</div>
												  ))
												: null}
										</div>
										<div className='main-image'>
											<img
												key={
													chatMessageIndex +
													(mainProductData &&
														(mainProductData.product_id ??
															mainProductData.productId))
												}
												className={isFading ? 'fade' : 'show'}
												src={
													mainProductData &&
													(mainProductData.media_link ??
														mainProductData.imageUrl)
												}
												alt=''
											/>
										</div>
									</div>
								</div>
								<div className='product-details-variants-and-add-to-bag'>
									<div className='details-variants'>
										<div className='recomm-details'>
											{whyRecommendReason && showRecommendation ? (
												<div className='why-recommend'>
													{textWithIcons(
														'Why do we recommend this?',
														whyRecommendReason
													)}
												</div>
											) : null}
										</div>
										<div className='variants'>
											{response &&
												response.choices &&
												response.choices.length > 0 && (
													<ProductVariants>
														<div className='choices'>
															{choices.map((choice, choiceIndex) => (
																<>
																	<div
																		key={choice.type + choiceIndex + 'choices'}
																		className={`group ${choiceIndex}`}>
																		<div className='title'>{choice.type}</div>
																		<RadioGroup
																			aria-label={choice.type}
																			name={choice.type}
																			value={
																				(selectedOptions[choiceIndex] &&
																					selectedOptions[choiceIndex].value) ||
																				''
																			}
																			onChange={(event) =>
																				handleChange(event, choiceIndex)
																			}>
																			{choice.values.map(
																				(value, valueIndex) => {
																					const isSelected =
																						selectedOptions[choiceIndex] &&
																						selectedOptions[choiceIndex]
																							.value === value;

																					return (
																						<FormControlLabel
																							className={
																								isSelected ? 'active' : ''
																							}
																							key={valueIndex + 'formCont'}
																							value={value}
																							control={<Radio />}
																							label={value}
																						/>
																					);
																				}
																			)}
																		</RadioGroup>
																	</div>
																</>
															))}
														</div>
													</ProductVariants>
												)}

											<div className='price-bag'>
												<div className='price'>
													{mainProductData && mainProductData.price !== '0' ? (
														<>
															<div className='sale-price'>
																<span>
																	{getCurrencySymbol(
																		mainProductData &&
																			(mainProductData.currency ??
																				mainProductData.currency)
																	)}
																</span>
																<span>
																	{NumberFormattinginLocale(
																		Math.floor(
																			Number(mainProductData.sale_price)
																		)
																	)}
																</span>
															</div>
															{Number(mainProductData.price) >
															Number(mainProductData.sale_price) ? (
																<>
																	<div className='striked-price'>
																		<span>
																			{getCurrencySymbol(
																				mainProductData &&
																					(mainProductData.currency ??
																						mainProductData.currency)
																			)}
																		</span>
																		<span>
																			{NumberFormattinginLocale(
																				Math.floor(
																					Number(mainProductData.price)
																				)
																			)}
																		</span>
																	</div>
																	<div className='discount-percent'>
																		{getDiscount(
																			mainProductData.price,
																			mainProductData.sale_price
																		)}
																		% off
																	</div>
																</>
															) : null}
														</>
													) : null}
												</div>
												<div className='add-to-bag-button'>
													<Button
														size='large'
														onClick={() => {
															window.open(
																mainProductData.product_url,
																'_blank'
															);
															// setShowAddtoBag(true);
															// let array = loadStateSession('FF-addbag')
															// 	? loadStateSession('FF-addbag')
															// 	: [];
															// array.push(mainProductData);
															// saveStateSession('FF-addbag', array);
														}}>
														Details
													</Button>
												</div>
											</div>
											<div
												className='desc'
												dangerouslySetInnerHTML={{
													__html: loadStateSession('FF-description'),
												}}></div>
										</div>
									</div>
								</div>
							</div>
							<div className='more-like-this'>
								{(moreLikeThisLoader || moreLikeThis.length > 0) && (
									<div className='heading'>
										<span className='text'>More Like This</span>
									</div>
								)}

								<div className={`complementaryproducts`}>
									<div className='morelikethiscontainer'>
										<Slidercarousel
											className={`slider-container ${
												moreLikeThis && moreLikeThis.length < slidesToShow
													? 'few-products'
													: ''
											}`}>
											<Slider
												{...settings}
												// ref={(slider) => setSlider(slider)}
											>
												{moreLikeThisLoader
													? Array.from({ length: slidesToShow }, (_, i) => (
															<ProductCard
																className={getAnimationClass(i)}
																key={chatMessageIndex + i + 'morelikeloader'}
																currency={''}
																media_link={''}
																title={
																	<div className='loader-text'>
																		<div className='ext1'></div>
																		<div className='ext2'> </div>
																	</div>
																}
																price={''}
																loading={true}
																index={0}
																noHover={true}
																sale_price={''}
															/>
													  ))
													: moreLikeThis &&
													  moreLikeThis.map((product, index) => (
															<div
																onClick={() => {
																	setMainProductData(product);
																	styleAdvisorAPICall(product.product_id);
																}}>
																<ProductCard
																	key={product.product_id + index}
																	currency={product.currency}
																	media_link={product.media_link}
																	title={product.title}
																	price={product.price}
																	sale_price={product.sale_price}
																	details={product}
																	noHover
																/>
																{/* <EcomCard
																	key={
																		product.product_id ??
																		product.productId + index
																	}
																	title={product.title}
																	price={product.price}
																	currency={getCurrencySymbol(product.currency)}
																	header={product.header}
																	mediaType={product.media_type}
																	mediaLink={product.media_link}
																	imageOnHover={product.media_link}
																	showDiscount={
																		product.category.toLowerCase() ===
																		'best deals'
																			? true
																			: false
																	}
																	colorMode={colorMode}
																	sale_price={product.sale_price}
																/> */}
															</div>
													  ))}
											</Slider>
										</Slidercarousel>
									</div>
								</div>
							</div>
						</div>
						{(loading || (currentProduct && currentProduct.length > 0)) && (
							<div className='ff-complete-the-look'>
								{
									<div className='heading'>
										<span className='ctl'>Complete the look</span>
									</div>
								}

								{loading ? (
									<>
										{Array.from({ length: 3 }, (_, i) => (
											<>
												<ProductCard
													className={getAnimationClass(i)}
													key={chatMessageIndex + i + 'morelikeloader'}
													currency={''}
													media_link={''}
													title={
														<div className='loader-text'>
															<div className='ext1'></div>
															<div className='ext2'> </div>
														</div>
													}
													price={''}
													loading={true}
													index={0}
													noHover={true}
													sale_price={''}
												/>
											</>
										))}
									</>
								) : (
									<>
										{currentProduct &&
											currentProduct.map((prod, index) => {
												let product = prod[0];
												if (index < 3) {
													return (
														<div
															onClick={() => {
																setMainProductData(product);
																styleAdvisorAPICall(product.product_id);
															}}>
															<ProductCard
																currency={product.currency}
																media_link={
																	product.imageUrl ?? product.media_link
																}
																title={product.title}
																price={product.price}
																productId={
																	product.product_id ?? product.productId
																}
																sale_price={
																	product.sale_price &&
																	product.sale_price.length == 0
																		? '0'
																		: product.sale_price
																}
																details={product}
																key={
																	product.product_id ??
																	product.productId +
																		'complete-the-look' +
																		index
																}
																noHover
															/>
														</div>
													);
												}
												return null;
											})}
									</>
								)}
							</div>
						)}
					</div>
				) : (
					<MobileProductDetailsWrapper
						className='mobile-details-wrapper'
						backgroundImage={mainProductsVariantImages[backgroundImageIndex]}
						onTouchStart={handleTouchStart}
						onTouchMove={handleTouchMove}
						onTouchEnd={handleTouchEnd}>
						<div className='image'></div>
						<div className='carousel-dots'>
							{mainProductsVariantImages.map((_, index) => (
								<>
									<svg
										onClick={() => {
											setBackgroundImageIndex(index);
										}}
										className={`dot ${
											index === backgroundImageIndex ? 'active' : ''
										}`}
										key={index}
										xmlns='http://www.w3.org/2000/svg'
										width={index === backgroundImageIndex ? '24' : '8'}
										height='10'
										viewBox={`0 0 ${
											index === backgroundImageIndex ? '24' : '8'
										} 8`}
										fill='none'>
										<rect
											x={index === backgroundImageIndex ? '0.5' : '0'}
											y='0.5'
											width={index === backgroundImageIndex ? '23' : '8'}
											height='8'
											rx={index === backgroundImageIndex ? '5' : '4'}
											fill={
												index === backgroundImageIndex
													? 'var(--primary-color-ff-primary600)'
													: 'var(--primary-color-ff-primary200)'
											}
											stroke={index === backgroundImageIndex ? 'white' : 'none'}
										/>
									</svg>
								</>
							))}
						</div>
						<div className='ff-chatbot-body2 brand-name'>
							{mainProductData && mainProductData.brand}
						</div>
						<div className='title ff-chatbot-h6'>
							{mainProductData && mainProductData.title}
						</div>
						{/* <div className='rating'>
							<div className='number'>4.5</div>
							<div className='stars'>
								{Array.from({ length: 5 }, (_, index) => (
									<>
										{index === 4 ? (
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='18'
												height='19'
												viewBox='0 0 18 19'
												fill='none'
											>
												<g id='star-half-light'>
													<path
														id='star-half'
														fill-rule='evenodd'
														clip-rule='evenodd'
														d='M4.91396 11.3036L3.43806 17.6306L9 14.2736L14.5619 17.6306L13.086 11.3036L18 7.04662L11.5291 6.49763L9 0.530624L6.47095 6.49763L0 7.04662L4.91396 11.3036ZM13.201 15.7579L9 13.2224V2.83698L10.9121 7.34852L15.7983 7.76303L12.0861 10.9791L13.201 15.7579Z'
														fill='#845B1D'
													/>
												</g>
											</svg>
										) : (
											<>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='18'
													height='19'
													viewBox='0 0 18 19'
													fill='none'
												>
													<g id='star-filled-light'>
														<path
															id='star-filled'
															d='M14.562 17.6306L9 14.2736L3.438 17.6306L4.914 11.3036L0 7.04662L6.471 6.49762L9 0.530624L11.529 6.49762L18 7.04662L13.086 11.3036L14.562 17.6306Z'
															fill='#845B1D'
														/>
													</g>
												</svg>
											</>
										)}
									</>
								))}
							</div>
							<div className='users ff-chatbot-body2'>(1k+)</div>
						</div> */}
						<div className='product-details-variants-and-add-to-bag-mobile'>
							<div className='details-variants'>
								<div className='recomm-details'>
									{whyRecommendReason && showRecommendation ? (
										<div className='why-recommend'>
											{textWithIcons(
												'Why do we recommend this?',
												whyRecommendReason
											)}
										</div>
									) : null}
								</div>
								<div className='variants'>
									{response &&
										response.choices &&
										response.choices.length > 0 && (
											<ProductVariants>
												<div className='choices'>
													{choices.map((choice, choiceIndex) => (
														<>
															<div
																key={choice.type + choiceIndex + 'choices'}
																className={`group ${choiceIndex}`}>
																<div className='title'>{choice.type}</div>
																<RadioGroup
																	aria-label={choice.type}
																	name={choice.type}
																	value={
																		(selectedOptions[choiceIndex] &&
																			selectedOptions[choiceIndex].value) ||
																		''
																	}
																	onChange={(event) =>
																		handleChange(event, choiceIndex)
																	}>
																	{choice.values.map((value, valueIndex) => {
																		const isSelected =
																			selectedOptions[choiceIndex] &&
																			selectedOptions[choiceIndex].value ===
																				value;

																		return (
																			<FormControlLabel
																				className={isSelected ? 'active' : ''}
																				key={valueIndex + 'formCont'}
																				value={value}
																				control={<Radio />}
																				label={value}
																			/>
																		);
																	})}
																</RadioGroup>
															</div>
														</>
													))}
												</div>
											</ProductVariants>
										)}
									<div
										className='desc'
										dangerouslySetInnerHTML={{
											__html: loadStateSession('FF-description'),
										}}></div>
								</div>
							</div>
						</div>
						<div className='price-bag'>
							<div>
								<div className='price'>
									{mainProductData && mainProductData.price !== '0' ? (
										<>
											<div className='sale-price'>
												<span>
													{getCurrencySymbol(
														mainProductData &&
															(mainProductData.currency ??
																mainProductData.currency)
													)}
												</span>
												<span>
													{NumberFormattinginLocale(
														Math.floor(Number(mainProductData.sale_price))
													)}
												</span>
											</div>
											{Number(mainProductData.price) >
											Number(mainProductData.sale_price) ? (
												<div className='striked-discount-price'>
													<div className='striked-price'>
														<span>
															{getCurrencySymbol(
																mainProductData &&
																	(mainProductData.currency ??
																		mainProductData.currency)
															)}
														</span>
														<span>
															{NumberFormattinginLocale(
																Math.floor(Number(mainProductData.price))
															)}
														</span>
													</div>
													<div className='discount-percent'>
														{getDiscount(
															mainProductData.price,
															mainProductData.sale_price
														)}
														% off
													</div>
												</div>
											) : null}
										</>
									) : null}
								</div>
								<div className='add-to-bag-button'>
									<Button
										size='large'
										onClick={() => {
											window.open(mainProductData.product_url, '_blank');
											// setShowAddtoBag(true);
											// let array = loadStateSession('FF-addbag')
											// 	? loadStateSession('FF-addbag')
											// 	: [];
											// array.push(mainProductData);
											// saveStateSession('FF-addbag', array);
										}}>
										Details
									</Button>
								</div>
							</div>
						</div>

						<div className='complete-the-look'>
							{(loading || (currentProduct && currentProduct.length > 0)) && (
								<div className='heading'>
									<span className='text'>Complete the look</span>
								</div>
							)}

							<div className={`complete-look`}>
								<div className='complete-look-container'>
									<Slidercarousel
										className={`slider-container ${
											currentProduct && currentProduct.length < slidesToShow
												? 'few-products'
												: ''
										}`}>
										<Slider
											{...settings1}
											// ref={(slider1) => setSlider1(slider1)}
										>
											{loading
												? Array.from({ length: slidesToShow }, (_, i) => (
														<ProductCard
															className={getAnimationClass(i)}
															key={chatMessageIndex + i + 'morelikeloader'}
															currency={''}
															media_link={''}
															title={
																<div className='loader-text'>
																	<div className='ext1'></div>
																	<div className='ext2'> </div>
																</div>
															}
															price={''}
															loading={true}
															index={0}
															noHover={true}
															sale_price={''}
														/>
												  ))
												: currentProduct &&
												  currentProduct.map((prod, index) => {
														let product = prod[0];
														if (index < 3) {
															return (
																<div
																	onClick={() => {
																		setMainProductData(product);
																		styleAdvisorAPICall(product.product_id);
																	}}>
																	<ProductCard
																		currency={product.currency}
																		media_link={
																			product.imageUrl ?? product.media_link
																		}
																		title={product.title}
																		price={product.price}
																		productId={
																			product.product_id ?? product.productId
																		}
																		sale_price={
																			product.sale_price &&
																			product.sale_price.length == 0
																				? '0'
																				: product.sale_price
																		}
																		details={product}
																		key={
																			product.product_id ??
																			product.productId +
																				'complete-the-look' +
																				index
																		}
																		noHover
																	/>
																	{/* <EcomCard
																key={
																	product.product_id ??
																	product.productId + index
																}
																title={product.title}
																price={product.price}
																currency={getCurrencySymbol(product.currency)}
																header={product.header}
																mediaType={product.media_type}
																mediaLink={product.media_link}
																imageOnHover={product.media_link}
																showDiscount={
																	product.category.toLowerCase() ===
																	'best deals'
																		? true
																		: false
																}
																colorMode={colorMode}
																sale_price={product.sale_price}
															/> */}
																</div>
															);
														}
														return null;
												  })}
										</Slider>
									</Slidercarousel>
								</div>
							</div>
						</div>
						<div className='more-like-this'>
							{(moreLikeThisLoader || moreLikeThis.length > 0) && (
								<div className='heading'>
									<span className='text'>More Like This</span>
								</div>
							)}

							<div className={`complementaryproducts`}>
								<div className='morelikethiscontainer'>
									<Slidercarousel
										className={`slider-container ${
											moreLikeThis && moreLikeThis.length < slidesToShow
												? 'few-products'
												: ''
										}`}>
										<Slider
											{...settings}
											// ref={(slider) => setSlider(slider)}
										>
											{moreLikeThisLoader
												? Array.from({ length: slidesToShow }, (_, i) => (
														<ProductCard
															className={getAnimationClass(i)}
															key={chatMessageIndex + i + 'morelikeloader'}
															currency={''}
															media_link={''}
															title={
																<div className='loader-text'>
																	<div className='ext1'></div>
																	<div className='ext2'> </div>
																</div>
															}
															price={''}
															loading={true}
															index={0}
															noHover={true}
															sale_price={''}
														/>
												  ))
												: moreLikeThis &&
												  moreLikeThis.map((product, index) => (
														<div
															onClick={() => {
																setMainProductData(product);
																styleAdvisorAPICall(product.product_id);
															}}>
															<ProductCard
																key={product.product_id + index}
																currency={product.currency}
																media_link={product.media_link}
																title={product.title}
																price={product.price}
																sale_price={product.sale_price}
																details={product}
																noHover
															/>
															{/* <EcomCard
																key={
																	product.product_id ??
																	product.productId + index
																}
																title={product.title}
																price={product.price}
																currency={getCurrencySymbol(product.currency)}
																header={product.header}
																mediaType={product.media_type}
																mediaLink={product.media_link}
																imageOnHover={product.media_link}
																showDiscount={
																	product.category.toLowerCase() ===
																	'best deals'
																		? true
																		: false
																}
																colorMode={colorMode}
																sale_price={product.sale_price}
															/> */}
														</div>
												  ))}
										</Slider>
									</Slidercarousel>
								</div>
							</div>
						</div>
					</MobileProductDetailsWrapper>
				)}
				{showAddtoBag ? (
					<>
						<Modal
							onClose={() => setShowAddtoBag(false)}
							removeFooter
							actionButtons={<></>}>
							<div className='addtobagmodel'>
								<div className='svg'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='49'
										height='48'
										viewBox='0 0 49 48'
										fill='none'>
										<g id='check_circle'>
											<path
												id='Vector'
												d='M24.5 4C13.46 4 4.5 12.96 4.5 24C4.5 35.04 13.46 44 24.5 44C35.54 44 44.5 35.04 44.5 24C44.5 12.96 35.54 4 24.5 4ZM20.5 34L10.5 24L13.32 21.18L20.5 28.34L35.68 13.16L38.5 16L20.5 34Z'
												fill='#4DAE89'
											/>
										</g>
									</svg>
								</div>
								<div className='title ff-chatbot-h5'>Added to Bag</div>
								<div className='desc'>
									{mainProductData && mainProductData.title}
								</div>
								<div className='buttons'>
									<Button
										size='large'
										onClick={() => {
											setShowAddtoBag(false);
											setProductAdded(true);
											enableCart();
										}}>
										View Bag
									</Button>
									<Button
										size='large'
										onClick={() => {
											setShowAddtoBag(false);
											setProductAdded(false);
										}}>
										Continue Shopping
									</Button>
								</div>
							</div>
						</Modal>
					</>
				) : null}
			</ProductDetailsWrapper>
		</>
	);
};

export default ProductDetails;
